<template>
    <div>
        <b-row class="mb-3">
            <Cabecalho
                :logo="atendimento.logoCliente"
                :nomeAssistencia="atendimento.assistencia"
            />
        </b-row>

        <DadosSolicitante
            :nomeSolicitante="atendimento.solicitante"
            :protocolo="atendimento.protocolo"
            :data="atendimento.dataAtendimento"
            :motivo="atendimento.motivo"
            :servicos="atendimento.servicos"
            :placa="atendimento.placa"
            :modelo="atendimento.modelo"
            :montadora="atendimento.montadora"
        />
        <div class="row" v-if="!temServicos || (temServicos && totalServicos == 1)">
            <HistoricoAtendimento 
                :exibirRastreioPrestadores="atendimento.exibirRastreioPrestadores"
                :status="temServicos && totalServicos == 1 ? servicos[Object.keys(servicos)[0]].status : atendimento.status"
                :horaStatus="temServicos && totalServicos == 1 ? servicos[Object.keys(servicos)[0]].horaStatus : atendimento.horaStatus"
                :enderecoOrigem="atendimento.enderecoOrigem"
                :enderecoDestino="atendimento.enderecoDestino"
                :anexos="atendimento.anexos"
                :servico="(temServicos && totalServicos == 1 ? servicos[Object.keys(servicos)[0]] : {})" 
                :idServicoAtendimento="(temServicos && totalServicos == 1 ? Object.keys(servicos)[0] : '')"
            />
        </div>
        <div class="row" v-else>
            <b-tabs v-if="temServicos" class="mt-3" fill style="width: 100%" id="servicos">
                <b-tab v-for="(servico, idServicoAtendimento) in ordernarServicos()" 
                    :key="idServicoAtendimento" 
                    :title="!$func.isEmpty(servico) ? servico.descricao : ''" 
                    @click="mudarAbaServico()"
                >
                    <HistoricoAtendimento 
                        :exibirRastreioPrestadores="atendimento.exibirRastreioPrestadores"
                        :status="servico.status"
                        :horaStatus="servico.horaStatus"
                        :enderecoOrigem="servico.segundaSaida ? servico.origemSegundaSaida : atendimento.enderecoOrigem"
                        :enderecoDestino="servico.segundaSaida ? servico.destinoSegundaSaida : atendimento.enderecoDestino"
                        :servico="servico" 
                        :idServicoAtendimento="idServicoAtendimento"
                    />
                </b-tab>
            </b-tabs>
        </div>

        <div class="row mt-4 mb-5" v-if="temAnexos">
            <b-col cols="12" class="pl-4 pr-4">
                <ListaAnexos :anexos="atendimento.anexos" />
            </b-col>
        </div>

        <div class="row mt-3 mb-3">
            <b-col cols="12">
                <Ajuda />
            </b-col>
        </div>

        <ModalEndereco/>
    </div>
</template>
<script>
import Cabecalho from "@/components/Cabecalho.vue";
import DadosSolicitante from "@/components/DadosSolicitante.vue";
import HistoricoAtendimento from "@/components/HistoricoAtendimento.vue";
import ListaAnexos from "@/components/ListaAnexos.vue";
import Ajuda from "@/components/Ajuda.vue";
import barramentoEndereco from '@/bus/endereco';
import ModalEndereco from '@/components/Mapa/ModalEndereco.vue';

// import { useToast, POSITION } from "vue-toastification";
import { mapGetters, mapState } from "vuex";

export default {
    components: {
        Cabecalho,
        DadosSolicitante,
        HistoricoAtendimento,
        ListaAnexos,
        Ajuda,
        ModalEndereco
    },
    computed: {
        ...mapGetters("Atendimento", {
            atendimento: "dadosAtendimento",
            servicos: "servicos",
        }),
        ...mapState('Atendimento', {
            temServicos: 'temServicos',
            totalServicos: 'totalServicos',
            temAnexos: 'temAnexos',
        })
    },
    created() {
    },
    methods: {
        ordernarServicos() {
            let servicosAbertos = {};
            let servicosFinializados = {};

            if (!this.$func.isEmpty(this.servicos)) {
                for (const idServicoAtendimento in this.servicos) {
                    if (Object.prototype.hasOwnProperty.call(this.servicos, idServicoAtendimento)) {
                        const servico = this.servicos[idServicoAtendimento];
                        if (servico.status == 'FINALIZADO' || !this.$func.isEmpty(servico.dataHorarioChegada)) {
                            servicosFinializados[idServicoAtendimento] = servico;
                        } else {
                            servicosAbertos[idServicoAtendimento] = servico;
                        }
                    }
                }      
            }
            let servicosOrdenados = Object.assign(servicosAbertos, servicosFinializados);
            return servicosOrdenados;
        },
        mudarAbaServico() {
            barramentoEndereco.$emit('centralizarMapa');
        }
    }
};
</script>
